import { useAppDispatch } from '../../../redux/hooks'
import { toggleShowHowItWorks } from '../../../redux/reducers/searchSlice'
import './style.scss'

function HowItWorksButton() {

	const dispatch = useAppDispatch()
	
	// const buttonClickHandler = () => {
	// 	if (subFilterSelectionIndex === index) {
	// 		dispatch(setFilterSelectionActive(!subFilterSelectionActive))
	// 	} else {
	// 		dispatch(setFilterSelectionActive(true))
	// 	}
	// 	dispatch(setFilterSelectionIndex(index))
	// }
	const buttonClickHandler = () => {
		dispatch(toggleShowHowItWorks())
	}

	return (
		<button 
			className={`how-it-works-button`}
			onClick={() => { buttonClickHandler() }}
		>
			<div className='how-it-works-button-icon'>
				<img
					src={`/imgs/icons/icon-how-it-works.svg`}
					alt={'Button Icon'}
				/>
			</div>
			<div className='how-it-works-button-value'>How It Works</div>
		</button>
	)
}

export default HowItWorksButton
